﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1.

export const systemUserId = 1;
export const cdnUrl = "https://sbb-rsucdn.azurewebsites.net";
export const dateFormat = "dd.MM.yyyy";
export const dateTimeFormat = "dd.MM.yyyy HH:mm";
export const dateRangeFormat = "dd.MM.yyyy - dd.MM.yyyy";
export const dayOfWeekDateFormat = "EEEE, dd.MM.yyyy";
export const dateTimeRangeFormat = "dd.MM.yyyy HH:mm - dd.MM.yyyy HH:mm";
export const timeFormat = "HH:mm";
export const systemUserUpn = "SYSTEM";
export const datePickerPlaceholder = "TT.MM.JJJJ";
